import React, { Fragment } from 'react';
import AbstractComponent from '../AbstractComponent';
import ContentMini from '../layout/content/ContentMini';
import LoginContent  from './LoginContent';

import './Login.css';

class Login extends AbstractComponent {
    constructor(props) {
        super(props);        

        this.state = {  
            preload: false,             
            erro: ''
        }        
    }                   

    componentDidMount() {                        
        this.onTitulo("Login");                                                
    } 
    
    render() {
        return (
            <Fragment>
                <ContentMini 
                    className="login"

                    preload={this.state.preload}                               
                    modalErro={this.state.erro}                                                  

                    onCloseAlerta={() => this.setState({erro: ''})}
                    
                    component={(props) => { 
                        return (
                            <LoginContent 
                                {...props}            
                                                                                                                                                
                                cidadesDisponiveis = {this.props.cidadesDisponiveis}          
                                inPreload={this.props.inPreload}
                                empresa={this.props.empresa}
                                
                                route={(item) => this.props.route(item)}  
                                
                                showPreload={(value) => this.setState({preload: value})}
                                onErro={(erro) => this.setState({erro: erro})}
                            />
                        )
                    }}
                />
            </Fragment> 
        )
    }
}

export default Login;